import { Switch } from "@mui/material";
import { type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";

import type { GroupPlugin } from "@/components/global/types";

import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";

export const pluginColumns = ["name", "status"];

export interface GroupPluginsColumnsProps {
  togglePlugin: (plugin: GroupPlugin) => void;
}

export default function GroupPluginsColumns({
	togglePlugin,
}: GroupPluginsColumnsProps): GridColDef<GroupPlugin>[] {
	return [
		{
			field: "name",
			headerName: "Name",
			editable: false,
			sortable: true,
			flex: 0.5,
			renderCell: (params: GridRenderCellParams<GroupPlugin>) => (
				<CoAppDataGridNameCell item={params.row} />
			),
		},
		{
			field: "status",
			headerName: "Status",
			editable: false,
			sortable: true,
			flex: 0.5,
			renderCell: (params: GridRenderCellParams<GroupPlugin>) => (
				<Switch
							checked={Boolean(params.row.activeForGroup)}
							disabled={!params.row.active}
							onChange={() => togglePlugin(params.row)}
						/>
			),
		},
		{
			field: "platformName",
			headerName: "Platform",
			editable: false,
			sortable: true,
			flex: 0.5,
			renderCell: (params: GridRenderCellParams<GroupPlugin>) => (
				<CoAppDataGridNameCell item={params.row.platformName} />
			),
		}
	];
}
